import { Injectable } from '@angular/core';


@Injectable()
export class RouterParams {
    public data: { [key: string]: any };

    public constructor(
    ) { }

    public get(param: string): any {
        if (this.data) {
            return this.data[param];
        }
        return undefined;
    }

    public set(data: { [key: string]: any }): void {
        this.data = data;
    }
}
